'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.filterProps = exports.boxShadows = exports.baseShadow = exports.shadowColor = exports.pill = exports.radius = exports.radii = exports.fontWeights = exports.bold = exports.regular = exports.fontSizes = exports.mono = exports.font = exports.space = exports.mediaQueries = exports.breakpoints = exports.cx = exports.colors = exports.brand = exports.grays = exports.palette = undefined

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _palx = require('palx')

var _palx2 = _interopRequireDefault(_palx)

var _lodash = require('lodash')

var _styledSystem = require('styled-system')

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var red = '#e42d42'
var blue = '#2d9ce4'
var palette = (exports.palette = (0, _palx2.default)(blue))

var grays = (exports.grays = {
  black: palette.black,
  slate: palette.gray[8],
  silver: palette.gray[7],
  smoke: palette.gray[2],
  snow: palette.gray[0],
  white: '#ffffff'
})

var brand = (exports.brand = {
  primary: red,
  accent: palette.indigo[4],
  success: palette.teal[5],
  info: palette.blue[5],
  warning: palette.orange[5],
  error: palette.red[7],
  muted: grays.silver
})

var colors = (exports.colors = _extends({}, brand, grays, palette))

var cx = (exports.cx = function cx(key) {
  return (0, _lodash.get)(colors, key, key)
})

var createMediaQuery = function createMediaQuery(n) {
  return '@media screen and (min-width:' + n + 'em)'
}

var addAliases = function addAliases(arr, aliases) {
  return aliases.forEach(function(key, i) {
    return Object.defineProperty(arr, key, {
      enumerable: false,
      get: function get() {
        return this[i]
      }
    })
  })
}

var breakpoints = (exports.breakpoints = [32, 48, 64, 80])

var mediaQueries = (exports.mediaQueries = breakpoints.map(createMediaQuery))

var aliases = ['sm', 'md', 'lg', 'xl']

addAliases(breakpoints, aliases)
addAliases(mediaQueries, aliases)

var space = (exports.space = [0, 4, 8, 16, 32, 64, 128, 256, 512])

var font = (exports.font = 'Averta,"Avenir Next","Segoe UI",Roboto,sans-serif')
var mono = (exports.mono = 'SFMono-Regular,"Roboto Mono",Menlo,monospace')

var fontSizes = (exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72, 96])

var regular = (exports.regular = 400)
var bold = (exports.bold = 700)

// styled-system's `fontWeight` function can hook into the `fontWeights` object
var fontWeights = (exports.fontWeights = {
  regular: regular,
  bold: bold

  // styled-system’s `borderRadius` function can hook into the `radii` object/array
})
var radii = (exports.radii = ['0px', '4px', '8px', '16px', '9999px'])
var radius = (exports.radius = '4px')
var pill = (exports.pill = radii[4])

var shadowColor = (exports.shadowColor = 'rgba(0,0,0,0.16)')
var baseShadow = (exports.baseShadow = '0 0 2px 0 rgba(0,0,0,.08),')
var boxShadows = (exports.boxShadows = [
  baseShadow + ('0 2px 4px 0 ' + shadowColor),
  baseShadow + ('0 4px 8px 0 ' + shadowColor),
  baseShadow + ('0 12px 12px 0 ' + shadowColor),
  baseShadow + ('0 24px 24px 0 ' + shadowColor)
])

var filterProps = (exports.filterProps = function filterProps(props) {
  return (0, _lodash.omit)((0, _styledSystem.removeProps)(props), [
    'theme',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'color',
    'bg',
    'fill',
    'fontSize',
    'f',
    'image',
    'maxWidth',
    'bold',
    'regular',
    'caps',
    'wrap',
    'size',
    'height',
    'boxShadowSize'
  ])
})

var theme = {
  breakpoints: breakpoints,
  mediaQueries: mediaQueries,
  space: space,
  mono: mono,
  font: font,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  regular: regular,
  bold: bold,
  colors: colors,
  radii: radii,
  radius: radius,
  pill: pill,
  boxShadows: boxShadows,
  shadowColor: shadowColor,
  cx: cx
}

exports.default = theme



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/theme.js
// module id = 2
// module chunks = 35783957827783 64691314399603 114276838955818 228131777832141